var _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNorway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Flag of Norway") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    fill: "#ba0c2f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 16,
    x: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 4,
    y: 6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#00205b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 16,
    x: 7
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 2,
    y: 7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorway);
export default __webpack_public_path__ + "static/media/norway.852e6c61ec647087c39e26f0dcbc5210.svg";
export { ForwardRef as ReactComponent };